<template>
    <div>
        <div class="form-group mb-4">
            <div class="d-flex justify-content-between">
                <div class="">
                    <label for="" v-if="removeTitle === false">
                        <strong>
                            Estimated Route
                        </strong>
                    </label>
                </div>
                <div class="">
                    <small>
                        <strong>
                            <span class="me-3">C = Collection</span>
                            D = Delivery
                        </strong>
                    </small>
                </div>
            </div>
            <div class="input-group">
                <img :src="routeImagePath" style="width: 100%" alt="Image of drivers route between collection and delivery locations" />
            </div>
        </div>
        <div class="input-group" v-if="mileage">
            <label for="">
                <strong>
                    Estimated Mileage
                </strong>
            </label>
            <div class="input-group">
                <span class="input-group-text triple">
                    <img
                        src='https://maps.google.com/mapfiles/ms/icons/green-dot.png'
                        class="map-icon"
                    />
                    <span class="map-arrow"><--></span>
                    <img
                        src='https://maps.google.com/mapfiles/ms/icons/red-dot.png'
                        class="map-icon"
                    />
                </span>
                <input class="form-control" placeholder="(awaiting route)" readonly="readonly" name="mileage" v-model="internalMileage" type="text" id="mileage">
            </div>
        </div>
    </div>
</template>

<style scoped>

    .map-icon {
        height: 14px;
    }

    .map-arrow {
        font-size: 8px;
    }

</style>


<script>

import { Loader } from "@googlemaps/js-api-loader";
import _ from 'lodash';

    export default {

        props: {
            collection : {
                type: Object,
                required: true
            },
            delivery : {
                type: Object,
                required: true
            },
            mileage : {
                type: Number,
                required: false
            },
            removeTitle : {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data() {
            return {
                prevInternalCollection: null,
                internalCollection: this.collection,

                prevInternalDelivery: null,
                internalDelivery: this.delivery,

                routeImagePath: '/images/movements/awaiting-route-placeholder.png',
                internalMileage: this.mileage,
            }
        },

        methods: {

            async loadLibraries() {
                const [ {LatLng}, {DirectionsService}, {DirectionsStatus}, {TravelMode}, {UnitSystem} ] = await Promise.all([
                    google.maps.importLibrary("core"),
                    google.maps.importLibrary("routes"),
                    google.maps.importLibrary("routes"),
                    google.maps.importLibrary("routes"),
                    google.maps.importLibrary("core"),
                ]);

                return { LatLng, DirectionsService, DirectionsStatus, TravelMode, UnitSystem };
            },

            async estimateMileage() {

                const { LatLng, DirectionsService, DirectionsStatus, TravelMode, UnitSystem } = await this.loadLibraries();
                const directionsService = new DirectionsService();

                if (!this.internalCollection.lat || !this.internalCollection.lng || !this.internalDelivery.lat || !this.internalDelivery.lng ) {
                    console.warn("Collection or delivery location is missing, cannot estimate mileage");
                    return;
                }

                if ( ( this.internalCollection.lat === this.internalDelivery.lat ) && ( this.internalCollection.lng === this.internalDelivery.lng ) ) {
                    console.warn("Collection and delivery are the same location, no need to estimate mileage");
                    return;
                }

                const collection = new LatLng(this.internalCollection.lat, this.internalCollection.lng);
                const delivery = new LatLng(this.internalDelivery.lat, this.internalDelivery.lng);

                directionsService.route({
                    origin: collection,
                    destination: delivery,
                    travelMode: TravelMode.DRIVING,
                    unitSystem: UnitSystem.IMPERIAL
                }, (result, status) => {
                    if (status === DirectionsStatus.OK) {

                        let sizeWidth = '1000';
                        let sizeHeight = '450';
                        const apiKey = 'AIzaSyD_tfgEUWxTtVczG5euJnkbeZ9DryHp4F4';

                        let routeLine = result.routes[0].overview_polyline;

                        this.routeImagePath = 'https://maps.googleapis.com/maps/api/staticmap?size=' + sizeWidth + 'x' + sizeHeight + '&markers=color:green%7Clabel:C%7C' + this.internalCollection.lat + ',' + this.internalCollection.lng + '&markers=color:red%7Clabel:D%7C' + this.internalDelivery.lat + ',' + this.internalDelivery.lng + '&path=color:0x1AB394FF%7Cenc:' + encodeURIComponent( routeLine ) + '&key=' + apiKey;

                        var travelled = 0;
                        result.routes[0].legs[0].steps.forEach(function(step) {
                            var wut = step.distance.text.split(" ");
                            if (wut[1] === "ft") {
                                travelled += parseFloat(wut[0]) / 5280;
                            }
                            else if (wut[1] === "mi") {
                                travelled += parseFloat(wut[0]);
                            }
                            else {
                                alert("Unhandled: ".wut[1]);
                            }
                        });

                        this.internalMileage = Math.ceil(travelled);

                        this.$emit('update-mileage', this.internalMileage);

                    }
                    else {
                        alert(status);
                    }
                });

            },

            debouncedEstimateMileage: _.debounce(function() {
                this.estimateMileage();
            }, 300),

        },

        async mounted() {

            const loader = new Loader({
                apiKey: 'AIzaSyD_tfgEUWxTtVczG5euJnkbeZ9DryHp4F4',
                version: "weekly",
                libraries: ["places", "geocoding", "maps", "marker"],
            });

            // This is used literally as a way to detect Google is loaded. We don't actually need to load a library here
            await loader.importLibrary('places');

            await this.estimateMileage();

        },

        watch: {
            collection: {
                handler(newVal, oldVal) {
                    if (!oldVal || newVal.lat !== oldVal.lat || newVal.lng !== oldVal.lng) {
                        this.internalCollection = newVal;
                        this.debouncedEstimateMileage();
                    }
                },
                deep: true
            },
            delivery: {
                handler(newVal, oldVal) {
                    if (!oldVal || newVal.lat !== oldVal.lat || newVal.lng !== oldVal.lng) {
                        this.internalDelivery = newVal;
                        this.debouncedEstimateMileage();
                    }
                },
                deep: true
            }
        },

    }
</script>
